import ApiBase from '@/sag-core/base/ApiBase'
import https from '@/apis/https.js'
import tools from '@/sag-core/tools'
import store from '@/store'
//取得所有產線

let api = null
api = tools.mergeDeep(new ApiBase(), {
    apiConvertRateDashboardWorkReport(data){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/APSSIDUI03/ConvertRateDashboardWorkReport',
            method: 'post',
            data: data
            /*
                data = {
                    Date: '2022/10/24'
                }
            */
        })
    }
})

if(store.state.webConfig.apiTest){
    api = tools.mergeDeep(new ApiBase(), {
        /**
         * @example
         * # apiGetAPSDashboard({
         * #     Date: '2022/10/24'
         * # })
         * @param {object} data 
         * @returns 
         */
        apiConvertRateDashboardWorkReport(data){
            return https({
                url: 'http://localhost:12345/APSSIDUI03/ConvertRateDashboardWorkReport',
                method: 'post',
                data: data
                /*
                    
                    
                    
                */
            })
        }
    })
}

export default api